const Alert = ({ message, hideAlert }) => {
  return (
    <div className={message.length > 1 ? "alert" : "alert-hidden"}>
      <p className="msg">{message}</p>
      <span className="closebtn" onClick={hideAlert}>
        &times;
      </span>
    </div>
  );
};

export default Alert;
